"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var cronEnums_1 = require("../cronEnums");
var lib_1 = require("../../../../lib");
var index_1 = require("../../index");
var Minutes = Array.from(Array(60).keys()).map(function (num) { return (num + ""); });
var MinutesGenerator = /** @class */ (function (_super) {
    tslib_1.__extends(MinutesGenerator, _super);
    function MinutesGenerator(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onChangeMinuteOption = function (option) {
            _this.setState({ activeMinuteButton: option });
            _this.generateCronMinutes();
        };
        _this.onSelectSpecificMinutes = function (minutes) {
            _this.setState({ specificMinutes: (minutes.length > 0) ? minutes : ["0"] });
            _this.generateCronMinutes();
        };
        _this.onSelectBetweenMinuteFrom = function (e) {
            var betweenMinuteTo = _this.state.betweenMinuteTo;
            _this.setState({ betweenMinuteFrom: e.target.value });
            if (Number(betweenMinuteTo) < Number(e.target.value)) {
                _this.setState({ betweenMinuteTo: (Number(e.target.value) + 1).toString() });
            }
            _this.generateCronMinutes();
        };
        _this.onSelectBetweenMinuteTo = function (e) {
            _this.setState({ betweenMinuteTo: e.target.value });
            _this.generateCronMinutes();
        };
        _this.state = {
            activeMinuteButton: cronEnums_1.MinutesOptions.EveryMinute,
            specificMinutes: ["0"],
            betweenMinuteFrom: "0",
            betweenMinuteTo: "59",
            cronMinutes: "0",
        };
        return _this;
    }
    MinutesGenerator.prototype.generateCronMinutes = function () {
        var _this = this;
        setTimeout(function () {
            switch (_this.state.activeMinuteButton) {
                case cronEnums_1.MinutesOptions.EveryMinute:
                    _this.setState({ cronMinutes: "*" });
                    break;
                case cronEnums_1.MinutesOptions.EveryMinuteBetween:
                    _this.setState({ cronMinutes: _this.state.betweenMinuteFrom + "-" + _this.state.betweenMinuteTo });
                    break;
                case cronEnums_1.MinutesOptions.SpecificMinute:
                    _this.setState({ cronMinutes: _this.state.specificMinutes.join(",") });
                    break;
            }
            _this.props.onGenerate(_this.state.cronMinutes);
        }, 10);
    };
    MinutesGenerator.prototype.render = function () {
        var theme = this.props.theme;
        var _a = this.state, activeMinuteButton = _a.activeMinuteButton, specificMinutes = _a.specificMinutes, betweenMinuteFrom = _a.betweenMinuteFrom, betweenMinuteTo = _a.betweenMinuteTo;
        return (React.createElement("div", null,
            React.createElement(lib_1.ButtonsGroup, { active: activeMinuteButton, onChange: this.onChangeMinuteOption, borders: true },
                React.createElement(lib_1.GroupButton, { name: cronEnums_1.MinutesOptions.EveryMinute }, "Every Minute"),
                React.createElement(lib_1.GroupButton, { name: cronEnums_1.MinutesOptions.SpecificMinute }, "Specific Minutes"),
                React.createElement(lib_1.GroupButton, { name: cronEnums_1.MinutesOptions.EveryMinuteBetween }, "Every Minute Between")),
            activeMinuteButton === cronEnums_1.MinutesOptions.EveryMinute && (React.createElement("div", null,
                React.createElement(index_1.Label, { className: theme.label }, "Run Every Minute"))),
            activeMinuteButton === cronEnums_1.MinutesOptions.SpecificMinute && (React.createElement("div", null,
                React.createElement(index_1.Label, { className: theme.label }, "Run On Specific Minutes"),
                React.createElement(index_1.MultiSelect, { surfaceLevel: 0, maxItems: 3, onSelectionChange: this.onSelectSpecificMinutes, searchable: true, value: specificMinutes, multiple: true, allowOnlySameGroupSelection: true },
                    React.createElement(index_1.MultiSelectGroup, { value: "selectAllMinutes", label: "Select All Minutes" }, Minutes.map(function (minute) { return (React.createElement(index_1.MultiSelectOption, { key: minute, value: minute, label: minute })); }))))),
            activeMinuteButton === cronEnums_1.MinutesOptions.EveryMinuteBetween && (React.createElement("div", null,
                React.createElement(index_1.Label, { className: theme.label }, "Run Every Minute Between"),
                React.createElement("div", { className: theme.between },
                    React.createElement(lib_1.FormSelect, { className: theme.select, searchable: true, items: Minutes.slice(0, 59), maxItems: 5, value: betweenMinuteFrom, onChange: this.onSelectBetweenMinuteFrom, label: "From Minute" }),
                    React.createElement(lib_1.FormSelect, { className: theme.select, searchable: true, items: Minutes.filter(function (min) { return Number(min) > Number(betweenMinuteFrom); }), maxItems: 5, value: betweenMinuteTo, onChange: this.onSelectBetweenMinuteTo, label: "To Minute" }))))));
    };
    MinutesGenerator.defaultProps = {};
    return MinutesGenerator;
}(React.Component));
exports.default = MinutesGenerator;
